import * as notifications from './notifications'
import * as modals from './modals'
import * as history from './history'
import * as loader from './loader'
import * as user from './user'
import * as feeds from './feeds'
import * as core from './core'
import * as pubsubRoom from './pubsubRoom'
import * as api from './api'
import * as currencies from './currencies'
import * as inputActive from './inputActive'
import * as rememberedOrders from './rememberedOrders'
import * as createWallet from './createWallet'
import * as ui from './ui'
import * as oneinch from './oneinch'
import * as transactions from './transactions'

export default {
  notifications,
  modals,
  history,
  loader,
  core,
  user,
  feeds,
  pubsubRoom,
  api,
  currencies,
  inputActive,
  rememberedOrders,
  createWallet,
  ui,
  oneinch,
  transactions,
}
